"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthError = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var AuthError = /*#__PURE__*/function (_Error) {
  (0, _inheritsLoose2.default)(AuthError, _Error);
  function AuthError(params) {
    var _this;
    var _ref = params || {},
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "Auth Unknown error" : _ref$message;
    _this = _Error.call(this, message) || this;

    // capturing the stack trace keeps the reference to your error class
    if (Error.captureStackTrace !== undefined) {
      Error.captureStackTrace((0, _assertThisInitialized2.default)(_this), _this.constructor);
    }
    return _this;
  }
  return AuthError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
exports.AuthError = AuthError;